"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.symbol.description.js");
var _paulCorePackage = require("paul-core-package");
var types = _interopRequireWildcard(require("../types/components"));
var _constants = require("../../utils/constants");
var _functions = require("../../utils/functions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Types = require("../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  buildingItemType,
  deviceType,
  equipmentIdType,
  HtgHxItemType,
  PwcPoeItemType,
  structureByIdType,
  structureType,
  valueItemType
} = _paulCorePackage.customPropTypes;
const {
  ComponentTypes
} = _paulCorePackage.constants;
const initialState = {
  errors: [],
  buildings: [],
  components: {},
  allPwhCByHtgSys: {},
  allHtgHxByHtgSys: {},
  activeBuildings: null,
  activePwhC: null,
  activeHtgHx: null,
  activeModels: {
    total: {
      [ComponentTypes.HtgSys]: {},
      [ComponentTypes.HtgSub]: {},
      [ComponentTypes.HtgHx]: {},
      [ComponentTypes.HtgPipe]: {},
      [ComponentTypes.HtgCc]: {},
      [ComponentTypes.PwhSupply]: {},
      [ComponentTypes.PwcPoe]: {},
      [ComponentTypes.PwhC]: {},
      [ComponentTypes.PwhPipe]: {}
    },
    byDependencies: {},
    sizes: {
      [ComponentTypes.HtgSys]: _constants.ModelWidth[ComponentTypes.HtgSys],
      [ComponentTypes.HtgHs]: _constants.ModelWidth[ComponentTypes.HtgHs],
      [ComponentTypes.HtgHx]: _constants.ModelWidth[ComponentTypes.HtgHx],
      [ComponentTypes.HtgPipe]: _constants.ModelWidth[ComponentTypes.HtgPipe],
      [ComponentTypes.HtgCc]: _constants.ModelWidth[ComponentTypes.HtgCc],
      [ComponentTypes.PwhSupply]: _constants.ModelWidth[ComponentTypes.PwhSupply],
      [ComponentTypes.PwcPoe]: _constants.ModelWidth[ComponentTypes.PwcPoe],
      [ComponentTypes.PwhC]: _constants.ModelWidth[ComponentTypes.PwhC],
      [ComponentTypes.PwhPipe]: _constants.ModelWidth[ComponentTypes.PwhPipe],
      connector: _constants.ModelWidth.connector
    },
    positions: _constants.defaultPositions,
    showModel: _constants.defaultShowModel
  },
  devices: {
    byId: {} // {[id]: device, ...}
  },
  values: {
    byId: {} // {[id]: device, ...}
  },
  selectedPoint: null,
  hasData: false
};
const components = exports.components = function components() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload: listenPayload = null,
    result: listenResult = null
  } = payload || {};
  const {
    components = {},
    activeBuildings,
    activePwhC,
    activeHtgHx
  } = state;
  switch (type) {
    case types.SET_INITIAL_STRUCTURE:
    case _paulCorePackage.listenerTypes.GET_DEVICES_LISTENER:
      {
        var _listenResult$devices;
        const BuildingIdList = _paulCorePackage.functions.getBuildingIdList({
          structure: listenResult.structure
        });
        const defActiveBuildingId = BuildingIdList && BuildingIdList[0] ? BuildingIdList[0][0] || null : null;
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: listenResult.structure,
          buildingId: defActiveBuildingId
        });
        const defActiveHtgHx = Object.keys(structure.active.HtgHx)[0] || null;
        const structureWithCalcHtgHx = _paulCorePackage.functions.getCurrentStructureWithHtgHx({
          structure: structure,
          activeHtgHx: defActiveHtgHx
        });
        const structureByDep = (0, _functions.getStructureByDependencies)({
          total: structureWithCalcHtgHx.active,
          activeHtgHx: defActiveHtgHx
        });
        const defActivePwhC = Object.keys(structureWithCalcHtgHx.active.PwhC)[0] || null;

        // console.log('MDM', listenPayload,
        //     '\n ================== \nActive Structure',
        //     structure.active,
        //     '\n ================== \ndevicesList',
        //     listenResult?.devices?.byId,
        //     '\n ================== \nstructureByDep',
        //     structureByDep,
        // )

        return _objectSpread(_objectSpread({}, state), {}, {
          buildings: listenResult === null || listenResult === void 0 ? void 0 : listenResult.buildings,
          components: listenResult.structure,
          activeModels: _objectSpread(_objectSpread({}, state.activeModels), {}, {
            total: structureWithCalcHtgHx.active,
            byDependencies: structureByDep.byDependencies,
            sizes: structureByDep.sizes,
            positions: structureByDep.positions,
            showModel: structureByDep.showModel
          }),
          allPwhCByHtgSys: structureWithCalcHtgHx.byHtgSys.PwhC,
          allHtgHxByHtgSys: structureWithCalcHtgHx.byHtgSys.HtgHx,
          activeBuildings: defActiveBuildingId,
          activePwhC: defActivePwhC,
          activeHtgHx: defActiveHtgHx,
          equipmentNames: listenResult.equipmentNames,
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: (listenResult === null || listenResult === void 0 || (_listenResult$devices = listenResult.devices) === null || _listenResult$devices === void 0 ? void 0 : _listenResult$devices.byId) || {}
          }),
          hasData: true
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUE_LISTENER:
      {
        var _listenResult$values;
        const device = state.devices.byId[listenPayload.thingPDIDDevice];
        if (!device) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: listenResult.devices.byId
          }),
          values: _objectSpread(_objectSpread({}, state.values), {}, {
            byId: (_listenResult$values = listenResult.values) === null || _listenResult$values === void 0 ? void 0 : _listenResult$values.byId
          })
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUES_LISTENER:
      {
        var _listenResult$values2;
        if (_paulCorePackage.functions.isEmpty(listenPayload)) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: listenResult.devices.byId
          }),
          values: _objectSpread(_objectSpread({}, state.values), {}, {
            byId: (_listenResult$values2 = listenResult.values) === null || _listenResult$values2 === void 0 ? void 0 : _listenResult$values2.byId
          })
        });
      }
    case _paulCorePackage.listenerTypes.UPDATE_TEMPERATURE_STATUSES_LISTENER:
      {
        var _listenResult$values3;
        return _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: listenResult.devices.byId
          }),
          values: _objectSpread(_objectSpread({}, state.values), {}, {
            byId: (_listenResult$values3 = listenResult.values) === null || _listenResult$values3 === void 0 ? void 0 : _listenResult$values3.byId
          })
        });
      }
    case types.SET_ACTIVE_BUILDINGS:
      {
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: components,
          buildingId: payload
        });
        const defActiveHtgHx = Object.keys(structure.active.HtgHx)[0] || null;
        const structureWithCalcHtgHx = _paulCorePackage.functions.getCurrentStructureWithHtgHx({
          structure: structure,
          activeHtgHx: defActiveHtgHx
        });
        const structureByDep = (0, _functions.getStructureByDependencies)({
          total: structureWithCalcHtgHx.active,
          activeHtgHx: defActiveHtgHx
        });
        // console.log('activeModels', structure.active, structureByDep)
        return _objectSpread(_objectSpread({}, state), {}, {
          activeBuildings: payload,
          activePwhC: Object.keys(structureWithCalcHtgHx.active.PwhC)[0] || null,
          activeHtgHx: Object.keys(structureWithCalcHtgHx.active.HtgHx)[0] || null,
          allPwhCByHtgSys: structureWithCalcHtgHx.byHtgSys.PwhC,
          allHtgHxByHtgSys: structureWithCalcHtgHx.byHtgSys.HtgHx,
          activeModels: _objectSpread(_objectSpread({}, state.activeModels), {}, {
            total: structureWithCalcHtgHx.active,
            byDependencies: structureByDep.byDependencies,
            sizes: structureByDep.sizes,
            positions: structureByDep.positions,
            showModel: structureByDep.showModel
          }),
          selectedPoint: null
        });
      }
    case types.SET_ACTIVE_PWH_C:
      {
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: components,
          buildingId: activeBuildings,
          activePwhC: payload
        });
        const structureWithCalcHtgHx = _paulCorePackage.functions.getCurrentStructureWithHtgHx({
          structure,
          activeHtgHx: activeHtgHx
        });
        const structureByDep = (0, _functions.getStructureByDependencies)({
          total: structureWithCalcHtgHx.active,
          activeHtgHx
        });
        // console.log('activeModels', structure.active, structureByDep)
        return _objectSpread(_objectSpread({}, state), {}, {
          activeModels: _objectSpread(_objectSpread({}, state.activeModels), {}, {
            total: structureWithCalcHtgHx.active,
            byDependencies: structureByDep.byDependencies,
            sizes: structureByDep.sizes,
            positions: structureByDep.positions,
            showModel: structureByDep.showModel
          }),
          activePwhC: payload,
          selectedPoint: null
        });
      }
    case types.SET_ACTIVE_HTG_HX:
      {
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: components,
          buildingId: activeBuildings,
          activePwhC: activePwhC
        });
        const structureWithCalcHtgHx = _paulCorePackage.functions.getCurrentStructureWithHtgHx({
          structure,
          activeHtgHx: payload
        });
        const structureByDep = (0, _functions.getStructureByDependencies)({
          total: structureWithCalcHtgHx.active,
          activeHtgHx: payload
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          activeModels: _objectSpread(_objectSpread({}, state.activeModels), {}, {
            total: structureWithCalcHtgHx.active,
            byDependencies: structureByDep.byDependencies,
            sizes: structureByDep.sizes,
            positions: structureByDep.positions,
            showModel: structureByDep.showModel
          }),
          activeHtgHx: payload,
          selectedPoint: null
        });
      }
    case types.SET_SELECTED_POINT:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPoint: payload
      });
    case types.RESET_ALL_COMPONENTS:
      {
        return initialState;
      }
    default:
      return state;
  }
};
components.propTypes = [_propTypes.default.shape({
  errors: _propTypes.default.arrayOf(_propTypes.default.shape({
    method: _propTypes.default.string
  })).isRequired,
  buildings: _propTypes.default.arrayOf(_propTypes.default.arrayOf(buildingItemType)).isRequired,
  components: structureType.isRequired,
  allPwhCByHtgSys: _propTypes.default.shape({
    [equipmentIdType]: PwcPoeItemType
  }).isRequired,
  allHtgHxByHtgSys: _propTypes.default.shape({
    [equipmentIdType]: HtgHxItemType
  }).isRequired,
  activeBuilding: _propTypes.default.string,
  activePwhC: _propTypes.default.string,
  activeHtgHx: _propTypes.default.string,
  activeModels: _propTypes.default.shape({
    total: structureType.isRequired,
    byDependencies: structureByIdType.isRequired,
    sizes: _propTypes.default.shape({
      [_propTypes.default.oneOf(Object.values(ComponentTypes))]: _propTypes.default.number,
      connector: _propTypes.default.number
    }).isRequired,
    positions: _propTypes.default.shape({
      [_propTypes.default.oneOf([...Object.values(_constants.TypesConnect), ...Object.values(_constants.TypesByDep)])]: _Types.VectorType
    }).isRequired,
    showModel: _propTypes.default.shape({
      [_propTypes.default.oneOf([...Object.values(_constants.TypesConnect), ...Object.values(_constants.TypesByDep)])]: _Types.VectorType
    }).isRequired
  }).isRequired,
  devices: _propTypes.default.shape({
    byId: _propTypes.default.shape({
      [equipmentIdType]: deviceType
    }).isRequired
  }).isRequired,
  values: _propTypes.default.shape({
    byId: _propTypes.default.shape({
      [equipmentIdType]: valueItemType
    }).isRequired
  }).isRequired,
  selectedPoint: _propTypes.default.shape({
    thingPDIDDevice: _propTypes.default.string
  }),
  hasData: _propTypes.default.bool
}), _propTypes.default.shape({
  type: _propTypes.default.string,
  payload: _propTypes.default.shape({})
})];